export const overlayVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const contentVariant = {
  initial: {
    scale: 1.1,
  },
  animate: {
    scale: 1,
    transition: { min: 0, max: 100, bounceDamping: 9 },
  },
  exit: {
    scale: 1.2,
    transition: { min: 0, max: 100, bounceDamping: 9 },
  },
};
